import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {
  currentOption: {
    brand: [],
    solution_category: [],
    industry_category: [],
    product_parent_category: [],
    product_child_category: [],
    download_file_category: [],
    contract_file_category: []
  },
};

export const getters = {
  hasOption(state) {
    return function (option) {
      return !!state.currentOption[option] && !!state.currentOption[option][0];
    };
  },
};

export const mutations = {
  SET_CURRENT_OPTION(state, options) {
    Object.keys(options)
      .forEach(option => {
        if(option === 'industry_category') {
          state.currentOption[option] = options[option].all
        } else {
          state.currentOption[option] = options[option]
        }
      })
  },
};

export const actions = {
  /**
   * 取得選項
   * @param commit
   * @param state
   * @param getters
   * @param types
   * @param useCached
   * @param storeCached
   * @returns {Promise<AxiosResponse<any>>}
   */
  fetchOptionList({
    commit,
    state,
    getters
  }, {
    types,
    useCached = false,
    storeCached = true
  }) {
    const noCachedTypeList = types.filter(option => {
      return !getters.hasOption(option)
    });
    const cached = () => {
      const cached = {};

      const hasCachedList = types.filter(option => {
        return getters.hasOption(option)
      });

      hasCachedList.forEach(option => {
        cached[option] = state.currentOption[option]
      });

      return cached;
    };
    const hasCached = noCachedTypeList.length === 0;

    return hasCached && useCached
      ? cached()
      : request
        .post(`/option/list`, {
          types: noCachedTypeList,
        }, {
          ...configRequest,
          name: 'fetchOptionList'
        })
        .then((response) => {
          const options = response.items;
          if(storeCached) {
            commit('SET_CURRENT_OPTION', options);
          }

          return options
        })
  },
};
